import React from 'react';
import PropTypes from 'prop-types';
import DownloadIcon from '@material-ui/icons/CloudDownloadOutlined';
import SendToSecureFilesIcon from '@material-ui/icons/FolderSharedOutlined';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import HoverMenu from 'Components/UI/HoverMenu';
import HoverMenuItem from 'Components/UI/HoverMenu/HoverMenuItem';

const styles = theme => ({
  root: {
    cursor: 'default',
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    border: `2px solid ${theme.palette.facet.lightGray}`,
    boxShadow: theme.shadows[1],
  },
});

const MessageImageHoverMenu = ({
  classes,
  onDownload,
  onSendToSecureFiles,
  sendingToSecureFiles,
  fileResource,
  isVisible,
}) => {
  if (!onDownload && !onSendToSecureFiles) {
    return null;
  }

  return (
    <HoverMenu
      className={classes.root}
      isVisible={isVisible}
    >
      <HoverMenuItem
        isVisible={onDownload}
        toolTipTitle="Download"
        icon={DownloadIcon}
        onClick={onDownload}
        test={`messages-hover-menu-download-button-${fileResource.link('self').url()}`}
      />
      <HoverMenuItem
        isVisible={onSendToSecureFiles}
        disabled={sendingToSecureFiles}
        toolTipTitle="Send to secure files"
        icon={SendToSecureFilesIcon}
        onClick={onSendToSecureFiles}
        test={`messages-hover-menu-send-to-secure-files-button-${fileResource.link('self').url()}`}
      />
    </HoverMenu>
  );
};

MessageImageHoverMenu.defaultProps = {
  onSendToSecureFiles: null,
  onDownload: null,
  sendingToSecureFiles: false,
};

MessageImageHoverMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  onSendToSecureFiles: PropTypes.func,
  onDownload: PropTypes.func,
  sendingToSecureFiles: PropTypes.func,
  fileResource: PropTypes.object.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

export default withStyles(styles)(MessageImageHoverMenu);
